import api from '../request/index';
import store from '../store'
//引入消息组件
import {Message,Loading} from "element-ui";
let dataList=[
  // {
  //   id:'1',
  //   title:'导航一',//中文名称
  //   name: 'TempData',//组件名称
  //   path: '#',//路由path
  //   component:'',//组件地址
  //   isAuth:false,//是否需要鉴权
  //   icon:'el-icon-location',//组件icon图标
  //   children:[
  //     {
  //       id:'1-1-1',
  //       title:'选项1',//中文名称
  //       name: 'TempData',//组件名称
  //       path: '/tempData',//路由path
  //       component:'views/TempData',//组件地址
  //       isAuth:false,//是否需要鉴权
  //       icon:'el-icon-location',//组件icon图标
  //       children:[]
  //     },
  //
  //   ]
  // }
];
//读取数据，path为#的不做路由
async function getDataList() {
  //如果不从后台读取，直接使用dataList即可
  //此处异步获取数据
  // const loading = Loading.service("数据初始化...");
  const res=await api.sys.leftMenus();
  // loading.close();
  // console.log("ajax-menu",res)
  if(res.code!=0)return Message.error(res.data)
  //获取的数据放入store，供左侧目录树使用
  store.commit("sys/SET_MY_MENU", res.data)
  //根据菜单返回路由数据
  return store.getters['sys/getRouters'];
}
export default {
  getDataList
};



// WEBPACK FOOTER //
// ./src/router/menuData.js